export default __webpack_public_path__ + "static/01_monthlyPass-af22cf88cd6653f41613912ef36221c0.jpg";